module.exports = __webpack_public_path__ + "static/media/loader-dark.128451f2.svg";